import AntLocalization from './AntLocalization';
import { unpack, pack } from 'msgpackr';
import stringify from './stableStringify';
import AntAuth from './AntAuth';

// Danh mục cấu hình khai `allowedCodesSetting`: chỉ giữ mã có trong setting (mảng) BE gửi kèm phiên — vd TaxCodes_All
// ↔ Tax_VAT_rate_codes (mức VAT của quốc gia theo country pack). Setting không có/rỗng → giữ nguyên danh mục.
export const filterLookupAllowedCodes = (lookup, busSettings) => {
    const values = lookup && lookup.values;
    if (!lookup || !lookup.allowedCodesSetting || !(values instanceof Array)) return values;
    const settings = busSettings !== undefined ? busSettings : AntAuth.getSessionInfo('bus_settings');
    const allowed = settings ? settings[lookup.allowedCodesSetting] : null;
    if (!(allowed instanceof Array) || !allowed.length) return values;
    return values.filter((v) => v !== null && v !== undefined && allowed.includes(typeof v === 'object' ? v.code : v));
};

export default class AntConfig {
    constructor(appGlobal, tableName) {
        this.appGlobal = appGlobal;
        this.tableName = tableName;
        this.cnfFields = [];
        this.loadedTables = [];
    }

    hasField(fieldName) {
        return this.cnfFields.some((f) => f.dataField === fieldName);
    }

    loadFields(tableName) {
        let found = this.loadedTables.find((l) => l.tableName === tableName);
        if (found) return found.cnfFields;

        var cnfFields = [];

        if (this.appGlobal && this.appGlobal.appConfig) {
            var Fields = this.appGlobal.appConfig.Fields;
            var DefaultFields = this.appGlobal.appConfig.DefaultFields;
            var Rules = this.appGlobal.appConfig.Rules;
            var Lookups = this.appGlobal.appConfig.Lookups;
            var Editors = this.appGlobal.appConfig.Editors;

            if (Fields) {
                var ar = Fields.find((e) => e.name === tableName);
                if (ar) ar = ar.value;
                if (!ar || ar instanceof Array === false) ar = [];

                const existingFields = new Set(ar.map((f) => f.dataField));
                if (!existingFields.has('created_at')) ar.push({ dataField: 'created_at', dataType: 'datetime' });
                if (!existingFields.has('updated_at')) ar.push({ dataField: 'updated_at', dataType: 'datetime' });
                if (!existingFields.has('created_user_code')) ar.push({ dataField: 'created_user_code', dataType: 'string' });
                if (!existingFields.has('created_user_name')) ar.push({ dataField: 'created_user_name', dataType: 'string' });
                if (!existingFields.has('creation_channel')) ar.push({ dataField: 'creation_channel', dataType: 'string' });
                if (!existingFields.has('business_code')) ar.push({ dataField: 'business_code', dataType: 'string' });
                if (!existingFields.has('approval_status')) ar.push({ dataField: 'approval_status', dataType: 'string' });

                var rs = null;
                if (Rules) {
                    rs = Rules.find((e) => e.name === tableName);
                    if (rs) rs = rs.value;
                }

                ar.forEach((f) => {
                    if (f.dataField) {
                        if (!f.dataType && String(f.dataField).endsWith('tags')) f.dataType = 'Array';
                        if (!f.dataType && String(f.dataField).endsWith('_amt')) f.dataType = 'currency';
                        if (!f.dataType && String(f.dataField).endsWith('_qty')) f.dataType = 'float';
                        if (!f.dataType && String(f.dataField).endsWith('_pct')) f.dataType = 'percent';
                        if (!f.dataType && String(f.dataField).endsWith('_at')) f.dataType = 'datetime';

                        if (rs && rs instanceof Array) {
                            var r = rs.find((e) => e.dataField === f.dataField);
                            if (r) {
                                f.clientRules = r.clientRules;
                                f.serverRules = r.serverRules;
                            }
                        }

                        var dfEndWithField = DefaultFields.find((e) => e.dataFieldEndWith && String(f.dataField).endsWith(e.dataFieldEndWith));
                        var dfField = DefaultFields.find((e) => e.dataField === f.dataField);
                        var objConf = { ...dfEndWithField, ...dfField, ...f, field: f.dataField };

                        if (Lookups && objConf.lookup && objConf.lookup.clientName) {
                            for (let i = 0; i < Lookups.length; i++) {
                                const item = Lookups[i];
                                if (item && item.value instanceof Array) {
                                    var l = item.value.find((e) => e.name === objConf.lookup.clientName);
                                    if (l && l.values) objConf.lookup.values = l.values;
                                }
                            }
                        }

                        cnfFields.push(objConf);
                    }
                });
            }
        }
        cnfFields = cnfFields.map((e) => {
            var clientRules = [];
            var serverRules = [];
            if (e.clientRules && e.clientRules instanceof Array)
                clientRules = clientRules.concat(
                    e.clientRules.map((r) => {
                        return { ...r, validationCallback: undefined };
                    })
                );
            if (e.serverRules && e.serverRules instanceof Array)
                serverRules = serverRules.concat(
                    e.serverRules.map((r) => {
                        return { ...r, validationCallback: undefined };
                    })
                );

            if (e.dataType === 'email') {
                if (!clientRules.find((f) => f.type === 'email')) clientRules.push({ type: 'email' });
                if (!clientRules.find((f) => f.type === 'stringLength')) clientRules.push({ type: 'stringLength', max: 60 });
            }
            if (e.dataType === 'phone') {
                if (!clientRules.find((f) => f.type === 'numberOnly')) clientRules.push({ type: 'numberOnly' });
            }

            return {
                ...e,
                clientRules: clientRules,
                serverRules: serverRules
            };
        });

        this.loadedTables.push({ tableName: tableName, cnfFields: cnfFields });

        return cnfFields;
    }

    configFields(defaultFields) {
        var cnfFields = this.loadFields(this.tableName);

        if (defaultFields instanceof Array) {
            defaultFields.forEach((f) => {
                var found = cnfFields.find((cf) => cf.dataField === f.dataField);
                if (found) {
                    Object.keys(f).forEach((key) => (found[key] = f[key]));
                }
            });
        }

        this.cnfFields = cnfFields;
        return cnfFields;
    }

    getCnfField(fieldName, tableName, level) {
        if (!fieldName) return null;

        var tblName = !tableName ? this.tableName : tableName;

        var found = null;

        if (tblName === this.tableName) {
            if (this.cnfFields.length <= 0) this.cnfFields = this.loadFields(tblName);
            found = this.cnfFields.find((f) => f.field === fieldName);
        } else {
            var cnfFields = this.loadFields(tblName);
            found = cnfFields.find((f) => f.field === fieldName);
        }

        if (!found) {
            if (this.appGlobal && this.appGlobal.appConfig) {
                var DefaultFields = this.appGlobal.appConfig.DefaultFields;

                var dfEndWithField = DefaultFields.find((e) => e.dataFieldEndWith && String(fieldName).endsWith(e.dataFieldEndWith));

                var dfField = DefaultFields.find((e) => e.dataField === fieldName);
                found = { ...dfEndWithField, ...dfField, field: fieldName };
            }
        }

        if (found && (!level || level <= 5)) {
            if (found.cnfField || found.cnfTable) {
                var fieldName2 = found.cnfField ? found.cnfField : found.dataField;
                var tableName2 = found.cnfTable ? found.cnfTable : tblName;
                var parentValue = this.getCnfField(fieldName2, tableName2, level ? level + 1 : 1);

                return { ...parentValue, visibleOnMain: undefined, visibleSelf: undefined, ...found, dataField: fieldName };
            }
        }

        return found;
    }

    getCnfEditor(editorName) {
        if (!editorName) return null;

        if (this.appGlobal && this.appGlobal.appConfig) {
            var Fields = this.appGlobal.appConfig.Fields;
            var Rules = this.appGlobal.appConfig.Rules;
            var Lookups = this.appGlobal.appConfig.Lookups;
            var Editors = this.appGlobal.appConfig.Editors;

            if (Editors) {
                for (let i = 0; i < Editors.length; i++) {
                    var edt = Editors[i];
                    if (edt && edt.value instanceof Array) {
                        var edt = edt.value.find((e) => e.name === editorName);
                        if (edt) {
                            if (Lookups) {
                                if (edt.lookup && edt.lookup.clientName) {
                                    for (let j = 0; j < Lookups.length; j++) {
                                        var lkp = Lookups[j];
                                        if (lkp && lkp.value instanceof Array) {
                                            lkp = lkp.value.find((e) => e.name === edt.lookup.clientName);
                                            // Ô chọn: chỉ mã hợp lệ của business (tính lại mỗi lần — theo phiên hiện tại).
                                            if (lkp && lkp.values) edt.lookup.values = filterLookupAllowedCodes(lkp);
                                        }
                                    }
                                }
                            }

                            return edt;
                        }
                    }
                }
            }
        }

        return null;
    }

    getCnfSearchGroups(tableName) {
        if (!tableName) return [];

        if (this.appGlobal && this.appGlobal.appConfig) {
            var SearchGroups = this.appGlobal.appConfig.SearchGroups;
            if (SearchGroups instanceof Array) {
                var found = SearchGroups.find((g) => g.name === tableName);
                if (found && found.value instanceof Array) return JSON.parse(stringify(found.value));
            }
        }

        return [];
    }

    getCnfSearchActions(tableName) {
        if (!tableName) return [];

        if (this.appGlobal && this.appGlobal.appConfig) {
            var SearchActions = this.appGlobal.appConfig.SearchActions;
            if (SearchActions instanceof Array) {
                var found = SearchActions.find((g) => g.name === tableName);
                if (found && found.value instanceof Array) return JSON.parse(stringify(found.value));
            }
        }

        return [];
    }

    getCnfVoucherActions(tableName) {
        if (!tableName) return [];

        if (this.appGlobal && this.appGlobal.appConfig) {
            var VoucherActions = this.appGlobal.appConfig.VoucherActions;
            if (VoucherActions instanceof Array) {
                var found = VoucherActions.find((g) => g.name === tableName);
                if (found && found.value instanceof Array) return JSON.parse(stringify(found.value));
            }
        }

        return [];
    }

    translateErrors(data, defaultError) {
        if (!data)
            return [defaultError ? AntLocalization.translateText(defaultError) : AntLocalization.translateText({ vi: 'Không thể truy xuất dữ liệu !', en: 'Connection timeout !', fr: 'Délai de connexion dépassé !', es: '¡Tiempo de conexión agotado!', id: 'Waktu koneksi habis!', ja: '接続がタイムアウトしました！', zh: '连接超时！', ko: '연결 시간 초과!', hi: 'कनेक्शन टाइमआउट!', ar: 'انتهت مهلة الاتصال!' })];

        var errors = [];

        if (data.error) {
            if (data.data instanceof Array && data.data.length > 0) {
                errors = data.data;
                errors = errors.map((e) => {
                    if (e.field) {
                        if (this.cnfFields instanceof Array) {
                            var fieldCnf = this.getCnfField(e.field);
                            if (fieldCnf) e.error = String(e.error).replace(e.field, fieldCnf.label);
                        }
                    }
                    return e;
                });
            } else if (typeof data.error === 'string') {
                if (data.field) {
                    if (this.cnfFields instanceof Array) {
                        var fieldCnf = this.getCnfField(data.field);
                        if (fieldCnf) data.error = String(data.error).replace(data.field, fieldCnf.label);
                    }
                }
                errors = [data.error];
            } else {
                errors = [
                    defaultError ? AntLocalization.translateText(defaultError) : AntLocalization.translateText({ vi: 'Không thể truy xuất dữ liệu !', en: 'Connection timeout !', fr: 'Délai de connexion dépassé !', es: '¡Tiempo de conexión agotado!', id: 'Waktu koneksi habis!', ja: '接続がタイムアウトしました！', zh: '连接超时！', ko: '연결 시간 초과!', hi: 'कनेक्शन टाइमआउट!', ar: 'انتهت مهلة الاتصال!' })
                ];
            }
        }
        return errors;
    }

    translateFirstError(data, defaultError) {
        var errors = this.translateErrors(data, defaultError);

        return errors.length > 0 ? errors[errors.length - 1] : null;
    }
}
